import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthProviderFactory } from '../../auth/auth-provider.factory';
import { AuthProvider } from '../../auth/auth.provider';

@Injectable({
  providedIn: 'root',
})
export class OrderSubscriptionSupportService {
  private readonly auth: AuthProvider =
    inject(AuthProviderFactory).getProvider('shop');

  private readonly router: Router = inject(Router);

  public tryToOrderAboTicket(ticketName: string): void {
    const ticketUrl = '/subscription-configuration/' + ticketName;

    const isUserLoggedIn: boolean = this.auth.isLoggedIn();
    if (isUserLoggedIn) {
      this.router.navigate([ticketUrl]);
    } else {
      this.auth.login(ticketUrl);
    }
  }
}
